<script setup lang="ts">
  withDefaults(defineProps<{ size?: number | string }>(), { size: 18 })
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M20.5 11.75A7.75 7.75 0 0 1 12 19.5a8.6 8.6 0 0 1-2.6-.4L5 20.5l1.35-3.6A7.6 7.6 0 0 1 3.5 11 7.75 7.75 0 0 1 12 3.5a7.75 7.75 0 0 1 8.5 8.25z"
    />
  </svg>
</template>
